import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
//const baseURL = 'http://192.168.0.15/eBikeServices/public/api/v1';
const baseURL = 'https://ebikerestservices.alvapy.com/api/v1';

axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);